'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

/**
 * Anchors on `/de/forbes/` and `/de/josy/` used to address sections that have
 * since become pages of their own. Old links still arrive with the hash, so
 * they are forwarded to the page that replaced the section.
 */
const HASH_REDIRECTS: Record<string, Record<string, string>> = {
  '/de/forbes/': {
    '#luxury-summit': '/de/faces-x-forbes-luxury-summit/',
    '#money-summit': '/de/forbes-money-summit/',
    '#womens-summit': '/de/forbes-women-summit/',
    '#30_under_30': '/de/forbes-under-30-november-2024/',
  },
  '/de/josy/': {
    '#finanzen': '/de/josy-finanzen/',
    '#recht': '/de/josy-recht/',
    '#versicherung': '/de/josy-versicherungen/',
  },
};

export const useLegacyHashRedirects = () => {
  const pathname = usePathname();

  useEffect(() => {
    const target =
      HASH_REDIRECTS[window.location.pathname]?.[window.location.hash];

    if (target) {
      window.location.href = target;
    }
  }, [pathname]);
};
